import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, gmTool } from "@/mixins/index";
import channelComMixins from "./mixins/channelComMixins";
import { hourlySummaryCk, hourlySummaryCkCurrency } from "@/api/dataPirate/channelData";
import * as echarts from "echarts";
export default {
  name: 'collect',
  mixins: [tabulation, channelComMixins, gmTool],
  data: function data() {
    return {
      name: 'collect',
      rawResponseData: {},
      fullTableData: [],
      activeChartChannel: '',
      // 当前图表展示的渠道 ID
      chartDataMap: {},
      keyVersion: '_v2'
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.searchData.game_id = this.rawData.game_id;
  },
  methods: {
    getDate: function getDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.searchData.date = date;
    },
    searchClick: function searchClick() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isverification, res, reqFn, today, currentHour, handleQueryData, queryData, rawData, summaryData, channelKeys, _channelKeys;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isverification = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
                // if(this.currencyClose && !this.searchData.currency_info){
                //   if(isverification){
                //     this.$message.error('请选择货币类型')
                //   }  
                //   return
                // }
                // 初始化响应对象
                res = {
                  data: {}
                }; // 从数据库获取数据
                //const storageKey = this.name + this.dataConvert() + this.keyVersion;
                // let dbres = await this.$DBControls.get(storageKey);
                // if(dbres && dbres.code == 500){
                //     this.searchClick()
                //     return
                //   }
                // 定义请求函数

                reqFn = _this.currencyClose ? hourlySummaryCkCurrency : hourlySummaryCk;
                _context.next = 5;
                return _this.getexchangeRate();

              case 5:
                if (_this.queryCurrency == 'VND') {
                  _this.screenList = _this.screenListVND;
                } else if (_this.queryCurrency == 'USD') {
                  _this.screenList = _this.screenListP;
                } else {
                  _this.screenList = _this.screenListP;
                }

                _this.tableDataList = _this.screenList;
                _this.screen = _this.screenList.map(function (i) {
                  return i.prop;
                }); // 今日日期

                today = _this.$times.theDay(); // 当前小时

                currentHour = _this.$times.theDay('HH');
                console.log("currentHour==", currentHour); // 数据处理函数

                handleQueryData = function handleQueryData(queryData, target) {
                  if (queryData.code === 200) {
                    var dataToUpdate = target || queryData.data;

                    if (today === _this.searchData.date) {
                      // for (let k in queryData.data) {
                      //   dataToUpdate[k] = queryData.data[k];
                      // }
                      for (var chId in queryData.data) {
                        if (!dataToUpdate[chId]) dataToUpdate[chId] = {};

                        if (chId === '汇总') {
                          dataToUpdate[chId] = queryData.data[chId];
                        } else {
                          for (var hour in queryData.data[chId]) {
                            dataToUpdate[chId][hour] = queryData.data[chId][hour];
                          }
                        }
                      }

                      console.log("dataToUpdate==", dataToUpdate); // dataToUpdate[currentHour] = queryData.data[currentHour];
                    } // this.$DBControls.update(storageKey, dataToUpdate);


                    res.data = dataToUpdate;
                  }
                };

                _this.reqLoading = true; // if (dbres) {
                //   if (today !== this.searchData.date) {
                //     res.data = dbres.content;
                //   } else {
                //     let list = [];
                //     const curHourNum = parseInt(currentHour, 10);
                //     for (let h = 0; h < curHourNum; h++) {
                //       let formattedHour = h < 10 ? '0' + h : '' + h;
                //       let num = 0;
                //       // 遍历所有渠道，累加该小时内所有的数值指标
                //       for (let chId in dbres.content) {
                //         const hourData = dbres.content[chId][formattedHour];
                //         if (hourData) {
                //           // 遍历该小时下的每一个字段属性求和（保持你以前求和 num 的判定逻辑）
                //           for (let key in hourData) {
                //             const val = Number(hourData[key]);
                //             if (!isNaN(val)) {
                //               num += val;
                //             }
                //           }
                //         }
                //       }
                //       // 如果这个小时所有渠道累加起来的总和为 0，则说明数据为空/失效，加入重新拉取列表
                //       if (num === 0) {
                //         list.push(formattedHour);
                //       }
                //     }
                //     // 加上当前小时
                //     list.push(currentHour);
                //     // 发起增量补全请求
                //     const queryData = await reqFn({
                //       ...this.searchData,
                //       ...this.defaultData(),
                //       hour: list.join(',')
                //     });
                //     handleQueryData(queryData, dbres.content);
                //   }
                // } else {

                _context.next = 15;
                return reqFn(_objectSpread(_objectSpread({}, _this.searchData), _this.defaultData()));

              case 15:
                queryData = _context.sent;
                handleQueryData(queryData); // }

                _this.reqLoading = false; // 初始化表格数据

                rawData = res.data || {};
                _this.tableData = []; // 存放全部渠道数据，供表格展示

                _this.chartDataMap = {}; // 分渠道存放数据，供图表展示

                summaryData = null;
                channelKeys = Object.keys(rawData);
                console.log("rawData===", rawData);
                channelKeys.forEach(function (chKey) {
                  if (chKey === '汇总') {
                    var item = _objectSpread({}, rawData[chKey]); // 汇率计算及精度转换


                    item['register_recharge_device_amountexchange'] = Number(item['register_recharge_device_amount'] || 0) * _this.exchangeRate;
                    item['register_recharge_account_amountexchange'] = Number(item['register_recharge_account_amount'] || 0) * _this.exchangeRate;
                    item['account_recharge_amountexchange'] = Number(item['account_recharge_amount'] || 0) * _this.exchangeRate;

                    _this.processingListTow.forEach(function (pItem) {
                      item[pItem] = _this.isyjfmvnd() ? Number(item[pItem]) * 100 : item[pItem];
                    });

                    _this.processingList.forEach(function (pItem) {
                      item[pItem] = _this.$utils.conversion(item[pItem]).toFixed(2);
                    });

                    summaryData = _objectSpread({
                      channel_mark: item.channel_mark || _this.$t('summaryLabel'),
                      channel_name: item.channel_name || '/',
                      hours: '/'
                    }, item);
                    return;
                  }

                  var hoursObj = rawData[chKey] || {};
                  var hourKeys = Object.keys(hoursObj).sort();
                  var chName = chKey;
                  var channelHourList = [];
                  hourKeys.forEach(function (hKey) {
                    var item = _objectSpread({}, hoursObj[hKey]);

                    if (item.channel_name) chName = item.channel_name; // 汇率计算及精度转换

                    item['register_recharge_device_amountexchange'] = Number(item['register_recharge_device_amount'] || 0) * _this.exchangeRate;
                    item['register_recharge_account_amountexchange'] = Number(item['register_recharge_account_amount'] || 0) * _this.exchangeRate;
                    item['account_recharge_amountexchange'] = Number(item['account_recharge_amount'] || 0) * _this.exchangeRate;

                    _this.processingListTow.forEach(function (pItem) {
                      item[pItem] = _this.isyjfmvnd() ? Number(item[pItem]) * 100 : item[pItem];
                    });

                    _this.processingList.forEach(function (pItem) {
                      item[pItem] = _this.$utils.conversion(item[pItem]).toFixed(2);
                    }); // 格式化整点区间


                    var idx = parseInt(hKey, 10);
                    var hourRange = "".concat(idx < 10 ? '0' + idx : idx, ":00 ~ ").concat(idx + 1 < 10 ? '0' + (idx + 1) : idx + 1, ":00");

                    var rowData = _objectSpread({
                      channel_mark: item.channel_mark || chKey,
                      channel_name: item.channel_name || chName,
                      hours: hourRange
                    }, item);

                    _this.tableData.push(rowData);

                    channelHourList.push(rowData);
                  });
                  _this.chartDataMap[chKey] = channelHourList;
                });

                if (summaryData) {
                  _this.tableData.push(summaryData);
                }

                if (_this.searchData.channel_list && _this.searchData.channel_list.length > 0) {
                  _this.activeChartChannel = _this.searchData.channel_list[0];
                } else {
                  // 2. 顶部没有选中时，默认选中后端接口/数据返回的第一条渠道
                  _channelKeys = Object.keys(rawData).filter(function (k) {
                    return k !== '汇总';
                  });

                  if (_channelKeys.length > 0) {
                    _this.activeChartChannel = _channelKeys[0];
                  } else if (_this.channelList.length > 0) {
                    _this.activeChartChannel = _this.channelList[0].channel_mark;
                  } else {
                    _this.activeChartChannel = '';
                  }
                } // 绘制图表


                _this.getescreenChart();

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleChartChannelChange: function handleChartChannelChange() {
      this.getescreenChart();
    },
    getescreenChart: function getescreenChart() {
      var chartDom = document.getElementById("echartcollect");
      if (!chartDom) return;

      if (this.echartcollect) {
        this.echartcollect.dispose();
      }

      this.echartcollect = echarts.init(chartDom); // 仅获取当前选中渠道的数据用于图表渲染

      var currentChartData = this.chartDataMap[this.activeChartChannel] || [];
      var xAxisData = currentChartData.map(function (item) {
        return item.hours;
      });
      var series = [];
      this.screenList.forEach(function (item) {
        series.push({
          name: item.label,
          type: "line",
          data: currentChartData.map(function (i) {
            return i[item.prop];
          }),
          smooth: true,
          symbol: "none"
        });
      });
      var option = {
        animationDuration: 3000,
        tooltip: {
          trigger: "axis",
          confine: true
        },
        legend: {
          width: '100%',
          icon: 'circle',
          itemHeight: 12,
          bottom: '0%',
          itemWidth: 15,
          inactiveColor: '#666666',
          formatter: ['{a|{name}}'].join('\n'),
          textStyle: {
            fontSize: 12,
            lineHeight: 12,
            rich: {
              a: {
                width: 120,
                verticalAlign: 'middle'
              }
            },
            padding: [0, 0, -2, -4]
          },
          selected: this.screenselected
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "18%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false
          },
          data: xAxisData
        },
        yAxis: [{
          type: "value",
          splitLine: {
            lineStyle: {
              type: "dashed"
            }
          },
          splitNumber: 5,
          axisLabel: {
            formatter: function formatter(value) {
              if (value >= 10000) return (value / 10000).toFixed(2) + "万";
              return value;
            }
          }
        }, {
          type: "value",
          splitNumber: 5,
          axisLabel: {
            formatter: function formatter(value, index) {
              if (value >= 10000) {
                return (value / 10000).toFixed(2) + "万";
              } else if (value >= 1000) {
                return value;
              } else {
                return value;
              }
            }
          }
        }],
        series: series
      };
      option && this.echartcollect.setOption(option, true);
      var that = this;
      this.echartcollect.on('legendselectchanged', function (params) {
        that.screenselected = JSON.parse(JSON.stringify(params.selected));
      });
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('channelId'),
        prop: 'channel_mark'
      }, {
        label: this.$t('channelName'),
        prop: 'channel_name'
      }, {
        label: this.$t('time'),
        prop: 'hours'
      }];
      this.tableDataList.forEach(function (item) {
        columns.push({
          label: item.label,
          prop: item.prop
        });
      });
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$t('hourlySummary')
      });
    }
    /**
    * 整点汇总 end
    */

  }
};